/**
 * One entry for InnerImageZoom `sources` / HTML `<picture><source>`.
 * Matches vue-inner-image-zoom: { srcSet, media?, type? }.
 */
export interface MediaPictureSource {
    srcSet: string;
    media?: string;
    type?: string;
}

/**
 * Drops invalid entries. Returns undefined if nothing usable (so callers can omit the prop).
 */
export function normalizePictureSources(
    sources: MediaPictureSource[] | undefined | null
): MediaPictureSource[] | undefined {
    if (!sources?.length) {
        return undefined;
    }
    const filtered = sources.filter((s) => s?.srcSet?.trim());
    return filtered.length ? filtered : undefined;
}
